<template>
  <div class="compatibility-list">
    <div class="compatibility-table-scroll">
      <div class="compatibility-table-grid" :style="tableStyle">
        <div class="compatibility-table-header" :style="gridStyle">
          <div
            v-for="column in columns"
            :key="column"
            class="compatibility-table-heading"
            :class="{ 'compatibility-status-column': statusColumns.includes(column) }"
          >
            {{ $t(`checker.legends.${column}`) }}
          </div>
        </div>
        <div class="compatibility-list-content-wrapper">
          <div
            v-for="(compat, index) in compatibilities"
            :key="`${type}-${compat.licencePlateNumber || compat.vin}-${index + 1}`"
            class="compatibility-table-row"
          >
            <CompatibilityInformation
              :compat="compat"
              :columns="columns"
              :gridStyle="gridStyle"
              :rowIndex="index"
              :tableType="type"
              @resolveBrandModel="handleResolveBrandModel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { CompatibilityResponse as Compatibility } from 'ctp-compatibility-checker';
import CompatibilityInformation from './CompatibilityInformation.vue';
import {
  compatibilityStatusColumns,
  compatibilityTableColumns,
  CompatibilityTableType
} from './tableColumns';
import './styles/compatibility-table.scss';

const props = defineProps<{
  compatibilities: Compatibility[];
  type: CompatibilityTableType;
}>();

const emit = defineEmits<{(event: 'resolveBrandModel', payload: {
    rowIndex: number;
    brand: string;
    model: string;
    compat: Compatibility;
    tableType: CompatibilityTableType;
  }): void;
}>();

const handleResolveBrandModel = (payload: {
  rowIndex: number;
  brand: string;
  model: string;
  compat: Compatibility;
}) => {
  emit('resolveBrandModel', { ...payload, tableType: props.type });
};

const columns = computed(() => compatibilityTableColumns[props.type]);
const statusColumns = compatibilityStatusColumns;
const gridStyle = computed(() => ({
  gridTemplateColumns: `repeat(${columns.value.length}, minmax(110px, 1fr))`
}));
const tableStyle = computed(() => ({ minWidth: `${columns.value.length * 140}px` }));
</script>
